export const toastTypeStyles = {
  success: {
    border: 'border-green-500/30',
    bgGlow: 'bg-green-500/10',
    iconColor: 'text-green-400',
    progressBg: 'bg-green-500',
  },
  error: {
    border: 'border-red-500/30',
    bgGlow: 'bg-red-500/10',
    iconColor: 'text-red-400',
    progressBg: 'bg-red-500',
  },
  warning: {
    border: 'border-yellow-500/30',
    bgGlow: 'bg-yellow-500/10',
    iconColor: 'text-yellow-400',
    progressBg: 'bg-yellow-500',
  },
  info: {
    border: 'border-blue-500/30',
    bgGlow: 'bg-blue-500/10',
    iconColor: 'text-blue-400',
    progressBg: 'bg-blue-500',
  },
};

export const container = "glass-panel p-4 rounded-2xl border shadow-2xl relative overflow-hidden pointer-events-auto transition-all";
export const innerWrapper = "flex items-start gap-3";
export const messageText = "flex-1 text-xs font-bold text-text-primary leading-relaxed pr-2";
export const closeBtn = "text-text-muted hover:text-text-primary shrink-0 transition-colors cursor-pointer";
export const progressBarContainer = "absolute bottom-0 left-0 w-full h-[3px] bg-white/10";
